import styled from 'styled-components';


export const Wrapper = styled.div`
  background: #8FFF00;
  color: #323467;
`;